export default __webpack_public_path__ + "static/media/mercadopagoqr_payment.1e60c930.jpeg";